"use client";

import { DialogContent, DialogTitle } from "@mui/material";
import { useCloneDialog } from "../Providers/CloneDialogContext";

export default function CloneDialogContent() {
  const { campaignIdsToClone } = useCloneDialog();

  return (
    <>
      <DialogTitle>
        {`Clone Campaign${campaignIdsToClone.length > 1 ? "s" : ""}`}
      </DialogTitle>
      <DialogContent>
        {`Are you sure you want to clone ${campaignIdsToClone.length} campaign${campaignIdsToClone.length === 1 ? "" : "s"}?`}
      </DialogContent>
    </>
  );
}
